import { IDateRange, IJobListTimestampRange, ISearchQuery } from "src/models";
import { createAction, createAsyncAction } from "typesafe-actions";

export type CloudAuthStatus = 'unknown' | 'valid' | 'invalid';
export type CloudAuthReason =
  | 'token_refresh_failed'
  | 'not_authorized'
  | 'api_401'
  | 'auth_check_failed';

export interface ICloudAuthState {
  status: CloudAuthStatus;
  reason?: CloudAuthReason;
  updatedAt: number;
}

export const setGrainProfileModalVisible = createAction('SET_GRAIN_PROFILE_MODAL_VISIBLE')<boolean>();

export const setSearchQuery = createAction('SET_SEARCH_QUERY')<ISearchQuery | undefined>();

export const setDateRange = createAction('SET_DATE_RANGE')<IDateRange | undefined>();

export const setGrainIdFilter = createAction('SET_GRAIN_ID_FILTER')<string | undefined>();

export const setCenterIdFilter = createAction('SET_CENTER_ID_FILTER')<string | undefined>();

export const setStateFilter  = createAction('SET_STATE_FILTER')<string | undefined>();

export const setDistrictFilter = createAction('SET_DISTRICT_FILTER')<string | undefined>();

export const setCurrentStack = createAction('SET_CURRENT_STACK')<string>();

export const setUserJobsCachedTimestampRange = createAction('SET_USER_JOBS_CACHED_TIMESTAMP_RANGE')<IJobListTimestampRange>();

export const setOrgJobsCachedTimestampRange = createAction('SET_ORG_JOBS_CACHED_TIMESTAMP_RANGE')<IJobListTimestampRange>();

export const resetFilters = createAction('RESET_FILTERS')<void>();

export const setNetworkStatus = createAction('SET_NETWORK_STATUS')<boolean>();

export const syncLocalJobsNow = createAction('SYNC_LOCAL_JOBS_NOW')<void>();

export const setCloudAuthStatus = createAction('SET_CLOUD_AUTH_STATUS')<ICloudAuthState>();

export const resetCloudAuthStatus = createAction('RESET_CLOUD_AUTH_STATUS')<void>();

export const reset = createAction('RESET')<void>();

export const logout = createAction('LOGOUT')<void>();

export const forceLogout = createAction('FORCE_LOGOUT')<void>();

export const forceLogoutHandled = createAction('FORCE_LOGOUT_HANDLED')<void>();

export const updateLocale = createAction('UPDATE_LOCALE')<string>();

export const setIndiGrainSelectedColumns = createAction('SET_INDI_GRAIN_SELECTED_COLUMNS')<number[]>();
